import './compat';
import '../scss/_main.scss';
import './configure-vue';

import { createApp } from 'vue';

import { i18n } from '@skinsoft/i18n';
import { Playground } from './app/component/playground';
import { dateTimeFormats, messages } from './locales'
import { router } from './router';

async function mount() {
    const app = createApp(Playground);
    app.use(router);
    app.use(await i18n(messages, dateTimeFormats));
    app.mount('#app');
}

mount();
